import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector:"categoria-marca-widget",
  templateUrl:"../../templates/widgets/categoria.marca.widget.template.html"
})
export class CategoriaMarcaWidgetComponent implements OnInit{

  @Input()
  datosCat:any;



  constructor(){}

  ngOnInit(): void {
    // console.log(this.datosCat);
  }
}

@Component({
  selector:"marca-venta-widget",
  templateUrl:"../../templates/widgets/marca.ventas.widget.template.html"
})
export class MarcaVentasWidgetComponent implements OnInit{


  @Input()
  datosCat:any;

  constructor(){

  }

  ngOnInit(): void {
  }

  currencyFormatting(value: number) {
    return `\$${Math.round(value).toLocaleString()}`;
  }
}


@Component({
  selector:"marca-categoria-colaborador",
  templateUrl:"../../templates/widgets/marca.categoria.colaborador.template.html"
})
export class MarcaCategoriaColaboradorComponent implements OnInit{
  marcas:any[] = [];

  @Input()
  datosCol:any;

  @Input()
  colaborador:any;

  constructor(){}

  ngOnInit(): void {

  }
}


